// extracted by mini-css-extract-plugin
export default {"eventMyDrafts__deleteModal":"EventMyDraft_eventMyDrafts__deleteModal__uTCRg","eventMyDrafts__deleteModal__text":"EventMyDraft_eventMyDrafts__deleteModal__text__BMLGr"};